import styled from "styled-components";
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'


const TitleComponent = styled.p`
    font-family: ${props => props.fontFamily};
    font-size: 100px;
    color: ${props => props.color};
    text-align: ${props => props.textAlign};
    /* word-break: break-all; */
    /* word-wrap: break-word; */
    margin-top: ${props => props.marginTop};
    @media only screen and ${devices.mobileS} {
        /* background-color: orange; */
        font-size: 50px;
        /* padding: 1em 0; */
    }
    @media only screen and ${devices.mobileM} {
        /* background-color: orange; */
        font-size: 50px;
        padding: 0.5em;
    }
    @media only screen and ${devices.tablet} {
        /* background-color: red; */
        font-size: 3rem;
    }
    @media only screen and ${devices.laptop}{
        /* background-color: green; */
        font-size: 100px;
    }
`
export const Title = (props)=>{
    return(
        <TitleComponent 
            textAlign={props.textAlign}
            marginTop={props.marginTop}
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            color={props.color}>
            {props.text}
        </TitleComponent>
    )
}


const TextComponent = styled.p`
    font-family: ${props => props.fontFamily};
    font-size: ${props => props.fontSize};
    color: ${props => props.color};
    text-align: ${props => props.textAlign};
    /* word-break: break-all; */
    /* word-wrap: break-word; */
    margin-top: ${props => props.marginTop};

`
export const Text = (props)=>{
    return (
        <TextComponent 
            textAlign={props.textAlign}
            marginTop={props.marginTop}
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            color={props.color}>
            {props.text}
        </TextComponent>
    )
}